import { Tracker } from '@yoursurprise/segment-analytics';
import { z, ZodError } from 'zod';
import type { TypedMiddleware } from '../store';
import {
  canBeCombinedWithOtherProductsInCartLoaded,
  productSwitched,
} from '../Product/action';
import fetch from '../../../../js/api/fetch';
import { productPageLoaded } from '../UI/action';
import { Environment } from '../Environment/state';
import ErrorLogger from '../../../../js/error-logger/ErrorLogger';

export const productCanBeCombinedWithOtherProductsInCartMiddleware: TypedMiddleware =
  (storeApi) =>
  (next) =>
  (action): void => {
    const { environment } = storeApi.getState().environment;

    if (
      (!productPageLoaded.match(action) && !productSwitched.match(action)) ||
      environment === Environment.NODE
    ) {
      next(action);
      return;
    }

    const { shouldCheck } = storeApi.getState().product.strongAlcoholCheck;

    if (!shouldCheck) {
      next(action);
      return;
    }

    const { productId } = storeApi.getState().product;

    const fetchUrl = `cart-content/isAllowedToAddProduct?productId=${String(productId)}`;

    fetch(fetchUrl)
      .then((res) =>
        res.json().then((parsedResponse) => {
          const isAllowedToBeAdded = z.boolean().parse(parsedResponse);

          storeApi.dispatch(
            canBeCombinedWithOtherProductsInCartLoaded(isAllowedToBeAdded),
          );

          if (parsedResponse === false) {
            new Tracker().track(
              'Product can not be combined with items in cart',
              {
                label: String(productId),
                productId: String(productId),
              },
            );
          }
        }),
      )
      .catch((e: unknown) => {
        // We'll assume it's allowed to add the product here. As a second line of defense, we also check if it's allowed in the cart.
        storeApi.dispatch(canBeCombinedWithOtherProductsInCartLoaded(true));

        if (e instanceof ZodError) {
          ErrorLogger.createFromGlobals()?.log(
            new Error(
              'Unexpected format when determining whether product may be added to cart',
            ),
            {
              productId,
            },
          );
        }
      });

    next(action);
  };
